import React from "react"

import PressCard from "../../Cards/PressCard"
import SliderCard from "../../Cards/SliderCard"
import AffiliateCard from "../../Cards/AffiliateCard"

const cardSelector = (contentType, data, cardColor, cardAlignment) => {

  switch (contentType) {
    case "press":
      return data.map(article => (
        <PressCard key={article.headline} article={article} inSlider={true} />
      ))
    case "affiliate":
      return data.map(affiliatePost => (
        <AffiliateCard
          key={affiliatePost.name}
          affiliatePost={affiliatePost}
          inSlider={true}
        />
      ))

    default:
      return data?.map(postData => (
        <SliderCard
          key={postData.title}
          contentType={contentType}
          postData={postData}
          cardColor={cardColor}
          cardAlignment={cardAlignment}
        />
      ))
      break
  }
}

export { cardSelector }